var map = {
	"./coliseum/about-us/bitcoin-stats.svg": "9faf",
	"./coliseum/about-us/energy-drink-stats.svg": "cbf8",
	"./coliseum/about-us/explain-1.svg": "62e6",
	"./coliseum/about-us/explain-2.svg": "a1a3",
	"./coliseum/about-us/pizza-stats.svg": "0a9b",
	"./coliseum/about-us/team-photo.svg": "ce1b",
	"./coliseum/arrow-down.svg": "125b",
	"./coliseum/avatar.svg": "706b",
	"./coliseum/backgrounds/background-about-us-mobile.svg": "9d1d",
	"./coliseum/backgrounds/background-create-match-modal.svg": "0c2c",
	"./coliseum/backgrounds/background-home.svg": "1ea1",
	"./coliseum/backgrounds/background-login-mobile.svg": "d3df",
	"./coliseum/backgrounds/background-login-modal.svg": "5ea1",
	"./coliseum/backgrounds/background-menu.svg": "bbac",
	"./coliseum/backgrounds/background-messages.svg": "8583",
	"./coliseum/backgrounds/background-mobile.svg": "78ab",
	"./coliseum/backgrounds/background-navbar-header.svg": "174d",
	"./coliseum/backgrounds/background-no-money.svg": "85e4",
	"./coliseum/backgrounds/background-user-rankings-mobile.svg": "3d6a",
	"./coliseum/backgrounds/background-user-rankings.svg": "0986",
	"./coliseum/banner-card-mobile.svg": "92fb",
	"./coliseum/competition-card-hover.svg": "4fae",
	"./coliseum/competition-card.svg": "309f",
	"./coliseum/faq-separator-mobile.svg": "fe03",
	"./coliseum/faq-separator.svg": "c748",
	"./coliseum/home/icon-matches.svg": "8569",
	"./coliseum/home/icon-players.svg": "d4c3",
	"./coliseum/home/icon-prizes.svg": "19c1",
	"./coliseum/logo-icon.svg": "bf20",
	"./coliseum/logo.svg": "2e7f",
	"./coliseum/message_duotone.svg": "d8ad",
	"./coliseum/mobile-logo.svg": "cdb8",
	"./coliseum/no-competitions.svg": "ca86",
	"./coliseum/referee-avatar.png": "4d1b",
	"./coliseum/steps/step1.svg": "7d2c",
	"./coliseum/steps/step2.svg": "d80d",
	"./coliseum/steps/step3.svg": "8c23",
	"./common/about-us/column.svg": "e901",
	"./common/about-us/logo.svg": "0dcf",
	"./common/about-us/team-photo-overlay.svg": "2d31",
	"./common/app-store-button.svg": "4d52",
	"./common/backgrounds/background-about-us-header-stains-mobile.svg": "feb0",
	"./common/backgrounds/background-about-us.svg": "b436",
	"./common/backgrounds/background-competition-no-money.svg": "d3a0",
	"./common/backgrounds/background-competitions-empty.svg": "f3e6",
	"./common/backgrounds/background-competitions-warriors.svg": "6348",
	"./common/backgrounds/background-contact-aboput-us.svg": "e0d4",
	"./common/backgrounds/background-error-stain1.svg": "01a9",
	"./common/backgrounds/background-error-stain2.svg": "1ec1",
	"./common/backgrounds/background-error-warriors.svg": "3536",
	"./common/backgrounds/background-footer.svg": "7bbd",
	"./common/backgrounds/background-free-bet-hover.svg": "511d",
	"./common/backgrounds/background-free-bet.svg": "b902",
	"./common/backgrounds/background-game-header.svg": "c48c",
	"./common/backgrounds/background-home.svg": "f0fc",
	"./common/backgrounds/background-menu.svg": "63c7",
	"./common/backgrounds/background-messages-separator.svg": "821b",
	"./common/backgrounds/background-messages-stain.svg": "a7bc",
	"./common/backgrounds/background-navbar-header.svg": "0da9",
	"./common/backgrounds/background-no-home.svg": "249a",
	"./common/backgrounds/background-sign-up-mobile.svg": "f607",
	"./common/backgrounds/background-stars-filled.svg": "6bf4",
	"./common/backgrounds/background-stars.svg": "cef0",
	"./common/backgrounds/background-user-profile.svg": "24f7",
	"./common/backgrounds/background-user-rankings-crown-mobile.svg": "10ba",
	"./common/backgrounds/background-user-rankings-crown.svg": "4e6d",
	"./common/backgrounds/background-user-rankings.svg": "a08c",
	"./common/backgrounds/button-big-modal.svg": "c249",
	"./common/backgrounds/button-modal.svg": "c56d",
	"./common/backgrounds/recover-account-background-mobile.svg": "e3db",
	"./common/backgrounds/recover-account-background.svg": "c8a9",
	"./common/backgrounds/result-loser-background-overlay.svg": "9ebb",
	"./common/backgrounds/result-loser-background.svg": "b92b",
	"./common/backgrounds/result-winner-background.svg": "6de8",
	"./common/backgrounds/selected-box-overlay-mobile.svg": "c84a",
	"./common/backgrounds/selected-box-overlay.svg": "a74d",
	"./common/backgrounds/timerbox-background.svg": "d207",
	"./common/banner-card-arrow.svg": "d2be",
	"./common/banner-card.svg": "6046",
	"./common/footer-section-active-background.svg": "5c36",
	"./common/game-header-footer.svg": "225e",
	"./common/google-play-button.svg": "52ac",
	"./common/home/stats-background.svg": "189b",
	"./common/home/steps-background-mobile.svg": "894e",
	"./common/home/steps-background.svg": "3eb8",
	"./common/icons/about-us.svg": "35cd",
	"./common/icons/add-round.svg": "927e",
	"./common/icons/add.svg": "bf43",
	"./common/icons/alert-round.svg": "a86c",
	"./common/icons/alert-triangle.svg": "56e0",
	"./common/icons/arrow-down.svg": "0776",
	"./common/icons/arrow-right.svg": "28e1",
	"./common/icons/back.svg": "9a1b",
	"./common/icons/blog.svg": "1cf9",
	"./common/icons/calendar.svg": "818a",
	"./common/icons/challenges.svg": "9e31",
	"./common/icons/chevron-right.svg": "3a42",
	"./common/icons/clock.svg": "e300",
	"./common/icons/copy.svg": "c474",
	"./common/icons/crossplay.svg": "364c",
	"./common/icons/daily.svg": "7d17",
	"./common/icons/danger.svg": "56a6",
	"./common/icons/decrement-arrow.svg": "958c",
	"./common/icons/document-check.svg": "b1fa",
	"./common/icons/edit.svg": "4071",
	"./common/icons/ellipse-filled.svg": "b2fc",
	"./common/icons/ellipse.svg": "8578",
	"./common/icons/email.svg": "a605",
	"./common/icons/expand-down.svg": "032b",
	"./common/icons/eye-off.svg": "7615",
	"./common/icons/eye.svg": "59b3",
	"./common/icons/filter-active.svg": "f098",
	"./common/icons/fire.svg": "5d96",
	"./common/icons/freematch.svg": "1d0d",
	"./common/icons/games.svg": "7a50",
	"./common/icons/google.svg": "ed02",
	"./common/icons/help.svg": "ae9d",
	"./common/icons/home.svg": "43e3",
	"./common/icons/hour.svg": "72cd",
	"./common/icons/identity-reverse.svg": "09e3",
	"./common/icons/identity.svg": "5b27",
	"./common/icons/increment-arrow.svg": "34dd",
	"./common/icons/info.svg": "cd69",
	"./common/icons/instagram.svg": "6bcf",
	"./common/icons/language.svg": "13cf",
	"./common/icons/loader.svg": "6234",
	"./common/icons/loading.svg": "d3da",
	"./common/icons/lock.svg": "07bf",
	"./common/icons/logo-icon.svg": "5d20",
	"./common/icons/map-pin.svg": "ede6",
	"./common/icons/matches-highlighted.svg": "c940",
	"./common/icons/matches.svg": "67b7",
	"./common/icons/menu.svg": "3c9e",
	"./common/icons/message.svg": "743b",
	"./common/icons/minigames.svg": "cd2b",
	"./common/icons/mobile.svg": "2bbe",
	"./common/icons/more-vertical.svg": "49e3",
	"./common/icons/new.svg": "ed81",
	"./common/icons/no-stars.svg": "9f51",
	"./common/icons/notification.svg": "a73f",
	"./common/icons/padlock.svg": "4726",
	"./common/icons/paperclip.svg": "02f9",
	"./common/icons/pc.svg": "68ed",
	"./common/icons/phone.svg": "6af8",
	"./common/icons/plus-circle.svg": "0073",
	"./common/icons/plus.svg": "cf6d",
	"./common/icons/position.svg": "e720",
	"./common/icons/prizes.svg": "eaa0",
	"./common/icons/pro.svg": "833d",
	"./common/icons/ps4-xboxone.svg": "3127",
	"./common/icons/ps4.svg": "735c",
	"./common/icons/ps5-xboxxs.svg": "d04b",
	"./common/icons/ps5.svg": "cbfc",
	"./common/icons/referee.svg": "f296",
	"./common/icons/screenshot.svg": "39ad8",
	"./common/icons/search.svg": "751f",
	"./common/icons/send.svg": "ba6e",
	"./common/icons/share.svg": "3f84",
	"./common/icons/smile.svg": "773b",
	"./common/icons/spinner.svg": "e7cd",
	"./common/icons/star-filled.svg": "5bf4",
	"./common/icons/star.svg": "fae0",
	"./common/icons/success.svg": "5cd2",
	"./common/icons/textarea.svg": "ec35",
	"./common/icons/timer.svg": "ea4b",
	"./common/icons/transger.svg": "e8f4",
	"./common/icons/twitch.svg": "8134",
	"./common/icons/twitter.svg": "51e3",
	"./common/icons/upload-success.svg": "99e2",
	"./common/icons/upload.svg": "58b6",
	"./common/icons/user-add.svg": "65e5",
	"./common/icons/user.svg": "ac03",
	"./common/icons/verified.svg": "2150",
	"./common/icons/wallet.svg": "be27",
	"./common/icons/weekly.svg": "17b5",
	"./common/icons/whatsapp.svg": "88f9",
	"./common/icons/x.svg": "5c38",
	"./common/icons/xbox-one.svg": "87f8",
	"./common/icons/xbox-xs.svg": "66ab",
	"./common/icons/youtube.svg": "3d4e",
	"./common/mobile-footer-menu-background.svg": "338a",
	"./common/mobile-footer-menu-separator.svg": "258c",
	"./common/no-competitions.svg": "3d56",
	"./common/payment-methods/american-express.svg": "54ac",
	"./common/payment-methods/apple-pay.png": "60d8",
	"./common/payment-methods/bizum-footer.svg": "1b4b",
	"./common/payment-methods/bizum.svg": "85f9",
	"./common/payment-methods/card.png": "4ad2",
	"./common/payment-methods/google-pay.png": "7c51",
	"./common/payment-methods/mastercard.svg": "ed2c",
	"./common/payment-methods/paypal.svg": "4f75",
	"./common/payment-methods/paypal_full.svg": "f191",
	"./common/payment-methods/visa.svg": "25ee",
	"./common/sidebar-amount-separator.svg": "db57",
	"./common/user-game-level-separator.svg": "b92e",
	"./common/verify-identity-divider.svg": "f15b",
	"./gamersfy/about-us/bitcoin-stats.svg": "4c46",
	"./gamersfy/about-us/divider-long.svg": "43e8",
	"./gamersfy/about-us/divider-short.svg": "bb1e",
	"./gamersfy/about-us/energy-drink-stats.svg": "a633",
	"./gamersfy/about-us/explain-1.svg": "1b91",
	"./gamersfy/about-us/explain-2.svg": "c825",
	"./gamersfy/about-us/pizza-stats.svg": "1cfa",
	"./gamersfy/about-us/separator.svg": "676e",
	"./gamersfy/about-us/stream-stats.svg": "1d35",
	"./gamersfy/about-us/team-photo.webp": "f93e",
	"./gamersfy/arrow-down.svg": "7689",
	"./gamersfy/attention.svg": "afc9",
	"./gamersfy/avatar.svg": "442e",
	"./gamersfy/backgrounds/background-about-us-mobile.svg": "8db9",
	"./gamersfy/backgrounds/background-about-us.svg": "1758",
	"./gamersfy/backgrounds/background-competition-ranked-card-mobile.svg": "b010",
	"./gamersfy/backgrounds/background-competition-ranked-card.svg": "9754",
	"./gamersfy/backgrounds/background-create-match-modal.svg": "ade0",
	"./gamersfy/backgrounds/background-create-match-success-modal.svg": "a9251",
	"./gamersfy/backgrounds/background-deposit-modal.svg": "2039",
	"./gamersfy/backgrounds/background-error-mobile.svg": "300e",
	"./gamersfy/backgrounds/background-error.svg": "fc6ad",
	"./gamersfy/backgrounds/background-footer-menu-mobile.svg": "ed7c",
	"./gamersfy/backgrounds/background-generic.svg": "c012",
	"./gamersfy/backgrounds/background-home.png": "3cc5",
	"./gamersfy/backgrounds/background-home.svg": "3e3e",
	"./gamersfy/backgrounds/background-install-app.png": "c628",
	"./gamersfy/backgrounds/background-invite-friend-mobile.svg": "c5fc",
	"./gamersfy/backgrounds/background-invite-friend.svg": "250b",
	"./gamersfy/backgrounds/background-lobby-mobile.jpg": "cef4",
	"./gamersfy/backgrounds/background-lobby.jpg": "58bf",
	"./gamersfy/backgrounds/background-login-mobile.svg": "0f44",
	"./gamersfy/backgrounds/background-login-modal.svg": "acfc",
	"./gamersfy/backgrounds/background-menu.svg": "218c",
	"./gamersfy/backgrounds/background-messages.svg": "2415",
	"./gamersfy/backgrounds/background-mobile.svg": "5761",
	"./gamersfy/backgrounds/background-navbar-header.svg": "8a27",
	"./gamersfy/backgrounds/background-no-money.svg": "ac11",
	"./gamersfy/backgrounds/background-ranked-classification-mobile.svg": "f50c",
	"./gamersfy/backgrounds/background-ranked-classification.svg": "7ea1",
	"./gamersfy/backgrounds/background-reminder-deposit-modal.svg": "bf77",
	"./gamersfy/backgrounds/background-user-rankings-mobile.svg": "dc8a",
	"./gamersfy/backgrounds/background-user-rankings.svg": "9075",
	"./gamersfy/backgrounds/background-wallet.svg": "0382",
	"./gamersfy/backgrounds/generic-banner.svg": "b7e5",
	"./gamersfy/backgrounds/multiplayer-competition-card-hover.svg": "eb9d",
	"./gamersfy/backgrounds/multiplayer-competition-card.svg": "5612",
	"./gamersfy/backgrounds/result-loser-button-background.svg": "417b",
	"./gamersfy/backgrounds/result-loser-trophy.svg": "6b9e",
	"./gamersfy/backgrounds/result-winner-button-background.svg": "9550",
	"./gamersfy/backgrounds/result-winner-trophy.svg": "dea9",
	"./gamersfy/banner-card-mobile.svg": "f2ef",
	"./gamersfy/banner-card.svg": "7fd7",
	"./gamersfy/box-border.png": "79d9",
	"./gamersfy/box-border.svg": "0e87",
	"./gamersfy/competition-card-hover.svg": "ba4c",
	"./gamersfy/competition-card.svg": "a0f9",
	"./gamersfy/download-app-banner-mobile.png": "2ed6",
	"./gamersfy/download-app-banner.png": "82f3",
	"./gamersfy/faq-separator-mobile.svg": "4c73",
	"./gamersfy/faq-separator.svg": "7762",
	"./gamersfy/gcoin.svg": "b4db",
	"./gamersfy/group-logo.png": "c005",
	"./gamersfy/header-separator.svg": "bb47",
	"./gamersfy/home/icon-hand.svg": "c765",
	"./gamersfy/home/icon-heart.svg": "9385",
	"./gamersfy/home/icon-matches.svg": "c49f",
	"./gamersfy/home/icon-players.svg": "51f4",
	"./gamersfy/home/icon-prizes.svg": "dc84",
	"./gamersfy/invite-friend-separator.svg": "854f",
	"./gamersfy/isotipo.svg": "a81f",
	"./gamersfy/landing-welcome/daily_rankings.png": "8ae3",
	"./gamersfy/landing-welcome/header/background/general.png": "e425",
	"./gamersfy/landing-welcome/header/background/general.webp": "c91b",
	"./gamersfy/landing-welcome/header/background/general_mobile.png": "eccd",
	"./gamersfy/landing-welcome/header/background/general_mobile.webp": "d1b8",
	"./gamersfy/landing-welcome/header/background/offer.png": "ca6a",
	"./gamersfy/landing-welcome/header/background/offer.webp": "d410",
	"./gamersfy/landing-welcome/header/background/offer_mobile.png": "ee0e",
	"./gamersfy/landing-welcome/header/background/offer_mobile.webp": "b38a",
	"./gamersfy/landing-welcome/minigames/flappy-goal.mp4": "fd36",
	"./gamersfy/landing-welcome/minigames/mobile_video_background.png": "e58f",
	"./gamersfy/landing-welcome/minigames/tap-tap.mp4": "f2d9",
	"./gamersfy/landing-welcome/minigames/wetris.mp4": "d28c",
	"./gamersfy/landing-welcome/multiplayer.png": "c4d5",
	"./gamersfy/landing-welcome/trophy.png": "6cc2",
	"./gamersfy/landing-welcome/versus.png": "92ce",
	"./gamersfy/logo-icon.svg": "19ed",
	"./gamersfy/logo.svg": "409e",
	"./gamersfy/message_duotone.svg": "4985",
	"./gamersfy/mobile-logo.svg": "3972",
	"./gamersfy/no-competitions.svg": "b5db",
	"./gamersfy/no-money.svg": "903b",
	"./gamersfy/ranked/position-1.svg": "e626",
	"./gamersfy/ranked/position-2.svg": "fcb4",
	"./gamersfy/ranked/position-3.svg": "9650",
	"./gamersfy/ranking/position-1.svg": "0a9a",
	"./gamersfy/ranking/position-2.svg": "84ac",
	"./gamersfy/ranking/position-3.svg": "3b04",
	"./gamersfy/referee-avatar.png": "fefc",
	"./gamersfy/roulette/roulette-center-image.png": "e4d6",
	"./gamersfy/roulette/roulette-no-prize.png": "fe45",
	"./gamersfy/roulette/roulette-overlay.png": "45d3",
	"./gamersfy/roulette/roulette-overlay2.png": "49bb",
	"./gamersfy/roulette/roulette-overlay3.png": "6743",
	"./gamersfy/roulette/roulette-overlay4.png": "209a",
	"./gamersfy/steps/step1.svg": "a390",
	"./gamersfy/steps/step2.svg": "ae57",
	"./gamersfy/steps/step3.svg": "1bdd",
	"./gamersfy/steps/step4.svg": "0e78",
	"./gamersfy/steps/step5.svg": "7b2a",
	"./gamersfy/steps/step6.svg": "df6d",
	"./gamersfy/steps/step7.svg": "709c",
	"./gamersfy/steps/step8.svg": "81fa",
	"./gamersfy/steps/step9.svg": "dd44",
	"./gamersfy/trophy-lost.svg": "c96f",
	"./gamersfy/trophy-won.svg": "d194",
	"./winnder/about-us/bitcoin-stats.svg": "69d3",
	"./winnder/about-us/divider-long.svg": "6ab3",
	"./winnder/about-us/divider-short.svg": "c60d",
	"./winnder/about-us/energy-drink-stats.svg": "7ecc",
	"./winnder/about-us/explain-1.svg": "33bc",
	"./winnder/about-us/explain-2.svg": "af5a",
	"./winnder/about-us/pizza-stats.svg": "0ba7",
	"./winnder/about-us/separator.svg": "1831",
	"./winnder/about-us/stream-stats.svg": "d19b",
	"./winnder/about-us/team-photo.webp": "0309",
	"./winnder/arrow-down.svg": "a88f",
	"./winnder/attention.svg": "1d24",
	"./winnder/avatar.svg": "286b",
	"./winnder/backgrounds/background-about-us-mobile.svg": "e460",
	"./winnder/backgrounds/background-about-us.svg": "0034",
	"./winnder/backgrounds/background-competition-ranked-card-mobile.svg": "419d",
	"./winnder/backgrounds/background-competition-ranked-card.svg": "2a28",
	"./winnder/backgrounds/background-create-match-modal.svg": "30c2",
	"./winnder/backgrounds/background-create-match-success-modal.svg": "5ef0",
	"./winnder/backgrounds/background-deposit-modal.svg": "d05a",
	"./winnder/backgrounds/background-error-mobile.svg": "8489",
	"./winnder/backgrounds/background-error.svg": "cf99",
	"./winnder/backgrounds/background-footer-menu-mobile.svg": "e75b",
	"./winnder/backgrounds/background-generic.svg": "7971",
	"./winnder/backgrounds/background-home-video.mp4": "9af4",
	"./winnder/backgrounds/background-home.png": "1cf1",
	"./winnder/backgrounds/background-install-app.png": "1075",
	"./winnder/backgrounds/background-invite-friend-mobile.svg": "a969",
	"./winnder/backgrounds/background-invite-friend.svg": "c472",
	"./winnder/backgrounds/background-lobby-mobile.jpg": "1604",
	"./winnder/backgrounds/background-lobby.jpg": "bb6b",
	"./winnder/backgrounds/background-login-mobile.svg": "b223",
	"./winnder/backgrounds/background-login-modal.svg": "0c71",
	"./winnder/backgrounds/background-menu.svg": "d270",
	"./winnder/backgrounds/background-messages.svg": "ee71",
	"./winnder/backgrounds/background-mobile.svg": "a0c2",
	"./winnder/backgrounds/background-navbar-header.svg": "8938",
	"./winnder/backgrounds/background-no-money.svg": "06d8",
	"./winnder/backgrounds/background-ranked-classification-mobile.svg": "a97c",
	"./winnder/backgrounds/background-ranked-classification.svg": "eed1",
	"./winnder/backgrounds/background-reminder-deposit-modal.svg": "5b9c",
	"./winnder/backgrounds/background-user-rankings-mobile.svg": "4c38",
	"./winnder/backgrounds/background-user-rankings.svg": "ef1c",
	"./winnder/backgrounds/background-wallet.svg": "176c",
	"./winnder/backgrounds/background-wetris.svg": "46c6",
	"./winnder/backgrounds/multiplayer-competition-card-hover.svg": "0ce1",
	"./winnder/backgrounds/multiplayer-competition-card.svg": "d11d",
	"./winnder/backgrounds/result-loser-button-background.svg": "1520",
	"./winnder/backgrounds/result-loser-trophy.svg": "7437",
	"./winnder/backgrounds/result-winner-button-background.svg": "67c0",
	"./winnder/backgrounds/result-winner-trophy.svg": "a990",
	"./winnder/banner-card-mobile.svg": "4d92",
	"./winnder/banner-card.svg": "d62e",
	"./winnder/box-border.png": "e1d9",
	"./winnder/competition-card-hover.svg": "51a5",
	"./winnder/competition-card.svg": "bbc3",
	"./winnder/download-app-banner-mobile.png": "2be2",
	"./winnder/download-app-banner.png": "5dfa",
	"./winnder/faq-separator-mobile.svg": "7d86",
	"./winnder/faq-separator.svg": "9962",
	"./winnder/group-logo.png": "f4ad",
	"./winnder/header-separator.svg": "8879",
	"./winnder/home/icon-hand.svg": "8abc",
	"./winnder/home/icon-heart.svg": "82df",
	"./winnder/home/icon-matches.svg": "daaa",
	"./winnder/home/icon-players.svg": "ead6",
	"./winnder/home/icon-prizes.svg": "01e6",
	"./winnder/invite-friend-separator.svg": "d571",
	"./winnder/isotipo.svg": "8ca7",
	"./winnder/landing-welcome/card-background.png": "6bcc",
	"./winnder/landing-welcome/coin1.png": "be8d",
	"./winnder/landing-welcome/coin2.png": "5f06",
	"./winnder/landing-welcome/daily_rankings.png": "3844",
	"./winnder/landing-welcome/games.png": "f131",
	"./winnder/landing-welcome/header/background/8-ball.jpg": "70e2",
	"./winnder/landing-welcome/header/background/8-ball.webp": "bb09",
	"./winnder/landing-welcome/header/background/cod.jpg": "ea74",
	"./winnder/landing-welcome/header/background/cod.webp": "69a7",
	"./winnder/landing-welcome/header/background/fifa.jpg": "801b",
	"./winnder/landing-welcome/header/background/fifa.webp": "f9ff",
	"./winnder/landing-welcome/header/background/general-1.jpg": "5411",
	"./winnder/landing-welcome/header/background/general-1.webp": "85bb",
	"./winnder/landing-welcome/header/background/general-juanfe.png": "da4d",
	"./winnder/landing-welcome/header/background/general-juanfe.webp": "2b9c",
	"./winnder/landing-welcome/header/background/general-video.jpg": "ef26",
	"./winnder/landing-welcome/header/background/general-video.webp": "d58a",
	"./winnder/landing-welcome/header/background/general.png": "10d5",
	"./winnder/landing-welcome/header/background/general.webp": "0662",
	"./winnder/landing-welcome/header/background/general_mobile.png": "22dc",
	"./winnder/landing-welcome/header/background/general_mobile.webp": "f0dd",
	"./winnder/landing-welcome/header/background/minigames.png": "c94a",
	"./winnder/landing-welcome/header/background/minigames.webp": "a47d",
	"./winnder/landing-welcome/header/background/minigames_mobile.png": "3428",
	"./winnder/landing-welcome/header/background/minigames_mobile.webp": "2854",
	"./winnder/landing-welcome/header/background/offer-1.png": "3132",
	"./winnder/landing-welcome/header/background/offer-1.webp": "70ca",
	"./winnder/landing-welcome/header/background/offer.png": "dad1",
	"./winnder/landing-welcome/header/background/offer.webp": "d247",
	"./winnder/landing-welcome/header/background/offer_mobile-1.png": "452a",
	"./winnder/landing-welcome/header/background/offer_mobile-1.webp": "dea4",
	"./winnder/landing-welcome/header/background/offer_mobile.png": "f776",
	"./winnder/landing-welcome/header/background/offer_mobile.webp": "84c4",
	"./winnder/landing-welcome/header/background/ufc.jpg": "9319",
	"./winnder/landing-welcome/header/background/ufc.webp": "3faf",
	"./winnder/landing-welcome/header/image/8-ball.png": "e805",
	"./winnder/landing-welcome/header/image/8-ball.webp": "6bed",
	"./winnder/landing-welcome/header/image/cod.png": "dd5b",
	"./winnder/landing-welcome/header/image/cod.webp": "b78c",
	"./winnder/landing-welcome/header/image/fifa-1.png": "74b6",
	"./winnder/landing-welcome/header/image/fifa-1.webp": "c6b0",
	"./winnder/landing-welcome/header/image/fifa.png": "636b",
	"./winnder/landing-welcome/header/image/fifa.webp": "7521",
	"./winnder/landing-welcome/header/image/general-video.png": "2c50",
	"./winnder/landing-welcome/header/image/general-video.webp": "caa8",
	"./winnder/landing-welcome/header/image/general.png": "e815",
	"./winnder/landing-welcome/header/image/general.webp": "3842",
	"./winnder/landing-welcome/header/image/ufc.png": "941c",
	"./winnder/landing-welcome/header/image/ufc.webp": "dff0",
	"./winnder/landing-welcome/individual_mode.png": "370d",
	"./winnder/landing-welcome/join.png": "fd83",
	"./winnder/landing-welcome/minigames/flappy-goal.mp4": "cb9f",
	"./winnder/landing-welcome/minigames/mobile_video_background.png": "71cd",
	"./winnder/landing-welcome/minigames/tap-tap.mp4": "4e90",
	"./winnder/landing-welcome/minigames/wetris.mp4": "9aba",
	"./winnder/landing-welcome/mobile-arrow.png": "dd61",
	"./winnder/landing-welcome/multiplayer.png": "b9ca",
	"./winnder/landing-welcome/title-container-background-end.png": "a112",
	"./winnder/landing-welcome/title-container-background-start.png": "77f9",
	"./winnder/landing-welcome/trophy.png": "e706",
	"./winnder/landing-welcome/versus.png": "111f",
	"./winnder/levels.svg": "8d79",
	"./winnder/logo-icon.svg": "1739",
	"./winnder/logo.svg": "3041",
	"./winnder/message_duotone.svg": "bd3c",
	"./winnder/mobile-logo.svg": "a81a",
	"./winnder/no-competitions.svg": "90ead",
	"./winnder/no-money.svg": "8cb6",
	"./winnder/ranked/position-1.svg": "f2d3",
	"./winnder/ranked/position-2.svg": "62c8",
	"./winnder/ranked/position-3.svg": "db84",
	"./winnder/ranking/position-1.svg": "ba5e",
	"./winnder/ranking/position-2.svg": "6c05",
	"./winnder/ranking/position-3.svg": "2293",
	"./winnder/referee-avatar.png": "fbb6",
	"./winnder/steps/step1.svg": "c11a",
	"./winnder/steps/step2.svg": "dc21",
	"./winnder/steps/step3.svg": "6444",
	"./winnder/steps/step4.svg": "b6b8",
	"./winnder/steps/step5.svg": "53af",
	"./winnder/steps/step6.svg": "e39a",
	"./winnder/steps/step7.svg": "65ee",
	"./winnder/steps/step8.svg": "d2ba",
	"./winnder/steps/step9.svg": "6751",
	"./winnder/trophy-lost.svg": "2ebb",
	"./winnder/trophy-won.svg": "011d",
	"./winnder/versus-match-box.svg": "2fcd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fb61";